import { BuilderTabs, BuilderList } from "./form-builder/FormBuilderTypes";

export const covertToCamel = (string: string) => {
  const formatedString =  string.toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "").replace(/[.,'\s]/g, '');
  
  return `${formatedString}`
};

export const getRequiredFields = (tab:BuilderTabs) => {
    return tab?.builders
    .filter((build: BuilderList) => build.required)
    .flatMap((builder: BuilderList) => {
      if (builder.type !== "file" || builder.title === "File" || builder.title === "Image") {
        const name = covertToCamel(builder.instruction || "");
        const key = builder.subtitle.length
          ? [...builder.subtitle.map((el: string) => covertToCamel(el)), name]
          : name;
        return key;
      } else {
        if (builder.title !== "File") {
          const name = covertToCamel(builder.title);
          const key = builder.subtitle.length
            ? [...builder.subtitle.map((el: string) => covertToCamel(el)), name]
            : name;
          return key;
        }
      }
    });
}
